<template>
  <div id="app">
    <tree></tree>
  </div>
</template>
<script>
  import tree from './components/tree.vue'
  export default {
    name      : 'app',
    components: {
      tree,
    },
  }
</script>

<style lang="less">
  @import "./styles/init";

  body{
    background-image: url(./assets/con-bg.png);
    background-size:385px 135px;
    background-position: center top;
    background-repeat: repeat;
    background-color: #e2c59c;
    background-attachment:fixed;
  }


  @media (min-width:768px){
    body{
      background-image: url(./assets/top-bg.jpg);
      background-size: auto;
      background-repeat: no-repeat;
      background-color: #000;

      &::-webkit-scrollbar{
        width: 1px;
        height: 20px;
        background-color: #e4c99d;
      }
      &::-webkit-scrollbar-thumb{
        background-color: #735c3c;

        &:hover{
          background-color: #5b472a;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue